import { UpgradeSTSResponse } from '@/types/api/mypage/g10STSInfo';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

/** 10Gアップグレード STS 情報取得APIのURL */
const apiUrl = ApiUrl.Read.UPGRADE_STS;

/**
 * 10Gアップグレード STS 情報取得APIの呼び出しフック。
 * アップグレード導線で必要な一時認証情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetUpgradeSTS = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<UpgradeSTSResponse>> => {
    const headers = await getSigV4HeadersForGet(apiUrl);
    return api.get(apiUrl, headers);
  }, []);

  return { execute };
};

export default useGetUpgradeSTS;
